module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('gmap-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.required && !_vm.field.hide
      }),
      expression: "{required: required && !field.hide}"
    }],
    ref: "inputRef",
    staticClass: "form-control",
    attrs: {
      "id": _vm.field.name,
      "name": _vm.field.name,
      "readonly": _vm.locked,
      "value": _vm.value,
      "data-vv-as": _vm.field.description.replace(/\./g, '')
    },
    on: {
      "place_changed": _vm.input
    },
    nativeOn: {
      "input": function($event) {
        return _vm.input.apply(null, arguments)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-281b7578","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/AddressRender.vue
// module id = 1586
// module chunks = 1